export const environment = {
  production: false,
  tracing: false,
  baseUrl: ''
};

import 'zone.js/plugins/zone-error';
